import styled from 'styled-components';

const Label = styled.div`
    margin-bottom: 5px;
    /* margin-left: 20px;
    margin-right: 20px; */
`;

export default Label;